import {
	SearchFilter,
	SearchFilterOptionText,
	SearchFilterOptionTextActive,
} from "../../../redux-magic/sub-interfaces/search-types";

export const _1_property_filter: SearchFilter = {
	id: "property_title",
	title: "property_title",
	level: 0,
	index: 2,
	presentation_type: "autocomplete_text_field",
	multi: false,
	affects: [],
	affected_by: [],
	priority: 1,
	is_advanced: false,
	included_in_search_bar: true,
	option_type: "text",
	possible_options: [] as Array<SearchFilterOptionText>,
	active_options: [] as Array<SearchFilterOptionTextActive>,
	selected_options: [] as Array<SearchFilterOptionText>,
	db_collection: "properties",
	db_field: "title",
	is_visible: false,
	is_applied: false,
	is_accordion_open: false,
};
